module.exports = __webpack_public_path__ + "static/media/icon-help-light.3cb7f3b4.svg";